import React from "react";
import { BaseModal } from "./BaseModal";
import { useStore } from "../../stores/store";
import { ModalKeys } from "../../interfaces/config";

export default function MaxRecordExceededModal() {
  const { isActive, deactivateTool } = useStore();
  return (
    <BaseModal
      active={isActive(ModalKeys.MAX_RESULTS_EXCEEDED)}
      title="PARCEL SEARCH"
    >
      <div className="p-3 font-helvetica text-sm">
        <p>Attention:</p>
        <p>
          You have searched for more parcels than the allowed limit of 5000. The
          first 5000 have been returned.
        </p>
      </div>
      <div className="bg-[#f5f5f5] border-t border-[#ddd] w-full text-right p-1">
        <button
          onClick={() => deactivateTool(ModalKeys.MAX_RESULTS_EXCEEDED)}
          className="btn-athena btn-sm mr-1"
        >
          Ok
        </button>
      </div>
    </BaseModal>
  );
}
